import React from "react";
import { Button, FormLabel, Grid } from "@material-ui/core";
import { useIntl } from "react-intl";
import PropTypes from 'prop-types';
import { getI18n } from "../../../utils/intl";
import { FilterByText } from "../../../pageComponents";

export const FilterByName = (props) => (
  <Grid item md={3} sm={4} xs={6}>
    <FilterByText {...props} />
  </Grid>
);

export const HeaderActionButtons = (props) => {
  const {
    classes = {},
    bulkActionsItemsCount,
    onAssign,
    onUnassign,
    disableAdd,
    disableRemove,
    id,
  } = props;

  const intl = getI18n(useIntl());

  return (
    <div className={classes.actionsFieldContainer}>
      <FormLabel className={classes.actionsLabel}>
        {intl.getI18nMessage('label.application.details.api.actions.count', { count: bulkActionsItemsCount })}
      </FormLabel>
      <Grid
        item md={12} sm={12} xs={12}
        className={classes.headerButtons}
      >
        <Button
          variant="contained" color="secondary"
          className={classes.addButton}
          id={`${id}-add`} data-apim-test={`${id}-add`} data-layer7-test={`${id}-add`}
          onClick={onAssign}
          disabled={disableAdd}
        >
          {intl.getI18nMessage('label.application.details.apis.actions.assign')}
        </Button>
        <Button
          variant="contained" color="secondary"
          className={classes.removeButton}
          id={`${id}-remove`} data-apim-test={`${id}-remove`} data-layer7-test={`${id}-remove`}
          onClick={onUnassign}
          disabled={disableRemove}
        >
          {intl.getI18nMessage('label.application.details.apis.actions.unassign')}
        </Button>
      </Grid>
    </div>
  );
}

HeaderActionButtons.propTypes = {
  classes: PropTypes.object,
  bulkActionsItemsCount: PropTypes.string,
  onAssign: PropTypes.func,
  onUnassign: PropTypes.func,
  disableAdd: PropTypes.string,
  disableRemove: PropTypes.string,
  id: PropTypes.string,
}